// The application must use the canonical Auth instance created in firebase.js.
// In particular, do not replace a restored Administrator session with an
// anonymous user while the browser is restoring local persistence.
import {auth, authStateReady} from "./firebase";

export {auth};
export const authReady = authStateReady;
